module.exports = __webpack_public_path__ + "img/floor_1A.dec97095.png";